export default __webpack_public_path__ + "static/media/Snd_2_Starts.1eeb1c84.mp3";